/**
 * CheckInCountdown.js
 *
 * "Check-in closes in 10:32:07": counts down to 3:00 PM IST on the day, when customs declarations close and the
 * cards go to print. Shows nothing once that's passed, or in the trial run (its check-in never closes).
 */

import React from "react";
import { Clock } from "lucide-react";
import { DECLARATIONS_CLOSE } from "../helpers/flyApi";
import { formatHms, isTrial, useTimeLeft } from "../helpers/flyPage";

const URGENT_MS = 60 * 60 * 1000;

/**
 * @param {String} accent       -   The guest's colour, if known
 * @param {String} className    -   Extra classes, e.g. for alignment
 */
const CheckInCountdown = ({ accent = "#1B2A41", className = "" }) => {
    const left = useTimeLeft(DECLARATIONS_CLOSE.toISOString(), true);
    if (isTrial() || left <= 0) return null;
    const urgent = left < URGENT_MS;
    return (
        <p className={`inline-flex items-center gap-2 rounded-full px-3.5 py-1.5 text-sm font-bold tracking-[0.06em] ${className}`}
            style={{ background: urgent ? "#A8183D" : accent, color: "#FBF7EF" }} role="timer" aria-live="off">
            <Clock size={15} aria-hidden="true" />
            Check-in closes in <span style={{ fontFamily: "'JetBrains Mono', monospace" }}>{formatHms(left)}</span>
        </p>
    );
};

export default CheckInCountdown;
